const TRANSPARENT_HEX_COLOR = "#00000000";
export {
  TRANSPARENT_HEX_COLOR
};
//# sourceMappingURL=colors.js.map
